<div class="instruction">
  <div class="table">
    <div class="video-row" *ngFor="let instruction of intructions">
      <span class="title">{{instruction.title}}</span>
      <span class="video-btn" (click)="showVideo(instruction)">Воспроизвести</span>
    </div>
  </div>
</div>

<app-modal-window *ngIf="videoModal" [title]="videoTitle" [visible]="videoModal" [scrollbar]="false" (close)="videoModal = $event"
  [width]="1100">

  <div class="video-modal">

    <video controls width="600" height="400">
      <source src="{{api + 'VideoInstruction/GetVideo?id=' + videoId}}" type="video/mp4" />
    </video>
  </div>

  <!-- <video width="400" controls>
      <source src="https://www.w3schools.com/css/mov_bbb.mp4" type="video/mp4">
      <source src="mov_bbb.ogg" type="video/ogg">
      Your browser does not support HTML5 video.
    </video> -->
</app-modal-window>
